import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import fairExImg from '../../assets/lpProducts/FairEx_Img.png';
import fairGenImg from '../../assets/lpProducts/FairGen_Img.png';
import FairGen from '../assets/img/FairGen2.svg';
import fairEx from '../assets/img/FairEx1.svg';
import FairExText from '../../assets/textImage/fairex-text.svg';
import FairGenText from '../../assets/textImage/fairgen-text.svg';
import StartCreatingButton from '../../components/StartCreatingButton ';

const productsData = {
  title:
    'AI content is reshaping our cultural and economic landscape, yet questions around ownership and ethics remain pressing. Saagas tackles these challenges using ',
  highlightedTitle: 'and FairGen',
  sections: [
    {
      title: 'FairEx',
      image: fairExImg,
      description: (
        <>
          A <strong>marketplace</strong> for fair, transparent, and secure collaboration that ensures <strong>true creators</strong> are treated with{' '}
          <strong>respect</strong>, <strong>dignity</strong>, and <strong>fairness</strong>.
        </>
      )
    },
    {
      title: 'FairGen',
      image: fairGenImg,
      description: (
        <>
          An <strong>AI Studio </strong> with state of the art <strong>image generation</strong> capabilities and feature rich <strong>canvas</strong>,
          delivering an exceptional creative experience.
        </>
      )
    }
  ],

  footerText: (
    <>
      Working in tandem
      <Box
        component="img"
        src={FairExText}
        alt="FairEx"
        style={{
          display: 'inline-block',
          verticalAlign: 'middle',
          height: '1.2em',
          margin: '0 4px',
          marginBottom: '4px'
        }}
      />
      and
      <Box
        component="img"
        src={FairGenText}
        alt="FairGen"
        style={{
          display: 'inline-block',
          verticalAlign: 'middle',
          height: '1.2em',
          margin: '0 4px',
          marginBottom: '4px'
        }}
      />
      enable Influencers, Brands and AI Creators to collaborate and create{' '}
      <strong>personalized commercial content with ease.</strong>
    </>
  )
};

const LPSectionProducts = () => {
  const theme = useTheme();
  const isMdOrBelow = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        px: { xs: 2, sm: 4 },
        pt: 10,
        pb: 10,
        [theme.breakpoints.down('md')]: {
          paddingTop: '0'
        }
      }}
    >
      {/* Main Heading */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          maxWidth: 1180,
          marginTop: '3rem',
          mb: 2,
          justifyContent: 'center',
          [theme.breakpoints.down('md')]: {
            marginTop: '2rem',
            maxWidth: '300px'
          }
        }}
      >
        <Typography
          fontFamily="Inter"
          variant="h4"
          sx={{
            fontWeight: 400,
            fontSize: '34px',
            color: '#C0C0C0',
            mb: 1,
            textAlign: 'center',
            [theme.breakpoints.down('md')]: {
              fontWeight: 300,
              fontSize: '16.8px',
              lineHeight: '130%',
              letterSpacing: '2px',
              textAlign: 'center',
              color: '#ffff'
            }
          }}
        >
          AI content is reshaping our cultural and economic landscape, yet questions around ownership and ethics remain pressing. Saagas tackles these
          challenges using{' '}
          <Box
            component="img"
            src={FairExText}
            alt="FairEx"
            style={{
              display: 'inline-block',
              verticalAlign: 'middle',
              height: '1.2em',
              margin: '0 4px',
              marginBottom: '4px'
            }}
          />
          and
          <Box
            component="img"
            src={FairGenText}
            alt="FairGen"
            style={{
              display: 'inline-block',
              verticalAlign: 'middle',
              height: '1.2em',
              margin: '0 4px',
              marginBottom: '4px'
            }}
          />
          .
        </Typography>
      </Box>

      {/* Sections */}
      <Box
        sx={{
          [theme.breakpoints.down('md')]: {
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem'
          }
        }}
      >
        {/* section 1 */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column-reverse', md: 'row' },
            width: '100%',
            maxWidth: 1260,
            minHeight: { xs: 'auto', md: 484 },
            gap: '40px',
            alignItems: 'center',
            mt: 6,
            mb: 4,
            [theme.breakpoints.down('md')]: {
              mt: 0,
              mb: 0,
              gap: '5px'
            }
          }}
        >
          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              display: 'flex',
              flexDirection: 'column',
              maxWidth: { xs: '100%', md: '360px' },
              alignItems: { xs: 'center', md: 'flex-start' },
              textAlign: { xs: 'center', md: 'left' }
            }}
          >
            <Box
              component="img"
              src={fairEx}
              alt="FairEx"
              sx={{
                height: 50,
                [theme.breakpoints.down('md')]: {
                  width: '80px',
                  height: '16px',
                  mt:2
                }
              }}
            />
            <Typography
              variant="h5"
              fontFamily="Inter"
              sx={{
                fontWeight: 300,
                lineHeight: '25px',
                fontSize: '20.16px',
                color: '#c0c0c0',
                mt: 2,
                mb: 4,
                [theme.breakpoints.down('md')]: {
                  fontWeight: 300,
                  fontSize: '16.8px',
                  lineHeight: '130%',
                  letterSpacing: '1px',
                  textAlign: 'center',
                  mt: 2
                }
              }}
            >
              {productsData.sections[0].description}
            </Typography>
          </Box>
          <Box sx={{ flex: 2, minWidth: 0, display: 'flex', justifyContent: 'center', backgroundColor: '#000000' }}>
            <Box
              component="img"
              src={productsData.sections[0].image}
              alt="Creator Image"
              sx={{
                display: 'block',
                width: '100%',
                maxWidth: 860,
                height: 'auto',
                border: '2px solid #FFFF',
                borderRadius: '12px'
              }}
            />
          </Box>
        </Box>

        {/* section 2 */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            width: '100%',
            maxWidth: 1260,
            minHeight: { xs: 'auto', md: 484 },
            gap: '40px',
            alignItems: 'center',
            mt: 10,
            mb: 4,
            [theme.breakpoints.down('md')]: {
              mt: 0,
              mb: 0,
              gap: '5px'
            }
          }}
        >
          {/* Image */}
          <Box sx={{ flex: 2, minWidth: 0, display: 'flex', justifyContent: 'center', backgroundColor: '#000000' }}>
            <Box
              component="img"
              src={productsData.sections[1].image}
              alt="Creator Image"
              sx={{
                display: 'block',
                width: '100%',
                maxWidth: 860,
                height: 'auto',
                border: '2px solid #FFFF',
                borderRadius: '12px',
              }}
            />
          </Box>

          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              display: 'flex',
              flexDirection: 'column',
              maxWidth: { xs: '100%', md: '360px' },
              alignItems: { xs: 'center', md: 'flex-start' },
              textAlign: { xs: 'center', md: 'left' }
            }}
          >
            <Box
              component="img"
              src={FairGen}
              alt="FairGen"
              sx={{
                height: 50,
                [theme.breakpoints.down('md')]: {
                  width: '80px',
                  height: '16px',
                  mt:2
                }
              }}
            />
            <Typography
              variant="h5"
              fontFamily="Inter"
              sx={{
                fontWeight: 300,
                lineHeight: '25px',
                fontSize: '20.16px',
                color: '#c0c0c0',
                mt: 2,
                [theme.breakpoints.down('md')]: {
                  fontWeight: 300,
                  fontSize: '16.8px',
                  lineHeight: '130%',
                  letterSpacing: '1px',
                  textAlign: 'center',
                  mt: 2
                }
              }}
            >
              {productsData.sections[1].description}
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Footer Text */}
      <Box sx={{ maxWidth: 1300, mb: 8, px: { xs: 2 } }}>
        <Typography
          fontFamily="Inter"
          variant="h6"
          sx={{
            fontWeight: 300,
            fontSize: 20,
            color: '#C0c0c0',
            mt: 4,
            textAlign: 'center',
            [theme.breakpoints.down('md')]: {
              fontWeight: 400,
              fontSize: '16.8px',
              lineHeight: '130%',
              letterSpacing: '1px',
              textAlign: 'center',
              mt: 8
            }
          }}
        >
          {productsData.footerText}
        </Typography>
        <Box
          sx={{
            mt: 0,
            [theme.breakpoints.down('md')]: {
              mt: 0
            }
          }}
        >
          <StartCreatingButton
            maxWidth={isMdOrBelow ? '131px' : '200px'}
            maxHeight={isMdOrBelow ? '49px' : '52px'}
            fontSize={isMdOrBelow ? '14px' : '16px'}
            padding={isMdOrBelow ? '8px 15px' : '16px 32px'}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default LPSectionProducts;
